const lang = {
  title: '完成報告書一覧',
  deleteReport: '削除してよろしいですか？',
  download: 'ダウンロード',
}

export default lang



// WEBPACK FOOTER //
// ./src/lang/ja/pages/project/completionReport.js